export default class ScrollToNamedAnchorManager {
  constructor() {
    this.offsetY = 48;
    this.init();
  }

  init() {
    this.watchPageLoadWithNamedAnchor();
    this.watchLinksToNamedAnchors();
    console.log("ScrollToNamedAnchorManager initialized");
  }

  watchPageLoadWithNamedAnchor() {
    const hash = window.location.hash;
    if (!hash || hash === "#") return;

    setTimeout(() => {
      let target = document.querySelector(hash) || document.querySelector(`[name='${hash.slice(1)}']`);
      const header = document.querySelector("header.header");
      const headerHeight = header ? header.offsetHeight : 0;

      if (target) {
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - headerHeight - this.offsetY,
          behavior: "smooth",
        });
      }
    }, 500);
  }

  watchLinksToNamedAnchors() {
    document.querySelectorAll('a[href^="#"], a[data-inner-link]').forEach(link => {
      link.addEventListener("click", (e) => {
        console.log("click");
        e.preventDefault();

        const targetId = link.getAttribute("href");
        let target = document.querySelector(targetId);
        if (!target) return;

        const header = document.querySelector("header.header");
        const headerHeight = header ? header.offsetHeight : 0;
        const oldId = target.id;

        // Temporarily change ID to avoid browser auto-scrolling
        target.id = `${oldId}tmp`;

        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - headerHeight - this.offsetY,
          behavior: "smooth",
        });

        // Restore the original ID after scrolling
        setTimeout(() => {
          window.location.hash = targetId;
          target.id = oldId;
        }, 900);
      });
    });
  }
}
